import React from 'react';
import {Field} from 'formik';
import {
    FormControl, FormHelperText,
    InputLabel, MenuItem, Select,
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2";


function LaveuseDataField({...props}) {
    const {values, errors, handleChange, handleBlur, operateurs} = props;

    return (
        <Grid container size={12} spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/*IMMAT FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Immatriculation <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.immatriculation}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.immatriculation && form.touched.immatriculation)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.immatriculation}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="immatriculation"
                                label="immatriculation"
                                autoFocus
                                helperText={
                                    form.errors.immatriculation &&
                                    form.touched.immatriculation &&
                                    String(form.errors.immatriculation)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/*DESCRIPTION FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Description
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.description}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.description && form.touched.description)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.description}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="description"
                                label="description"
                                autoFocus
                                helperText={
                                    form.errors.description &&
                                    form.touched.description &&
                                    String(form.errors.description)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>


            {/*TELEMETRY PROVIDER FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Fournisseur télématique
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name={"telemetryProvider"}
                        value={values.telemetryProvider}>
                        {({form}) => (
                            <FormControl fullWidth error={Boolean(form.errors.telemetryProvider)}>
                                <InputLabel id="label-telemetryProvider">Sélectionner le fournisseur :</InputLabel>
                                <Select
                                    labelId="label-telemetryProvider"
                                    label="Sélectionner le fournisseur :"
                                    variant="outlined"
                                    name="telemetryProvider"
                                    value={values.telemetryProvider}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="quartix">Quartix</MenuItem>
                                    <MenuItem value="samsara">Samsara</MenuItem>
                                </Select>
                                {form.errors.telemetryProvider &&
                                    String(form.errors.telemetryProvider) &&
                                    <FormHelperText error={true}>{form.errors.telemetryProvider}</FormHelperText>}
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/*TELEMETRY EXTERNAL ID FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Identifiant télématique
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.telemetryExternalId}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.telemetryExternalId && form.touched.telemetryExternalId)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.telemetryExternalId}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="telemetryExternalId"
                                label="telemetryExternalId"
                                autoFocus
                                helperText={(form.errors.telemetryExternalId && form.touched.telemetryExternalId) ? String(form.errors.telemetryExternalId) : undefined}/>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/*CO2 EMISSION FIELD*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Emission co2 en g/km
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        value={values.emissionCo2}>
                        {({field, form}) => (
                            <TextField
                                error={
                                    Boolean(form.errors.emissionCo2 && form.touched.emissionCo2)
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.emissionCo2}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="emissionCo2"
                                label="emissionCo2"
                                autoFocus
                                helperText={
                                    form.errors.emissionCo2 &&
                                    form.touched.emissionCo2 &&
                                    String(form.errors.emissionCo2)
                                }/>
                        )}
                    </Field>
                </Grid>
            </Grid>

            {/*OPERATEUR FIELDS*/}
            <Grid container size={12} alignItems={"center"}>
                <Grid size={3}>
                    <Typography>Affecter à l'opérateur</Typography>
                </Grid>
                <Grid size={9}>
                    <Field
                        type="text"
                        name={"operateur"}
                        value={values.operateur}>
                        {({form, push, remove}) => (
                            <FormControl fullWidth error={Boolean(errors.operateur)}>
                                <InputLabel id="label-operateur">Sélectionner l'opérateur :</InputLabel>
                                <Select
                                    labelId="label-operateur"
                                    label="Sélectionner l'opérateur :"
                                    variant="outlined"
                                    name="operateur"
                                    value={values.operateur}
                                    onChange={handleChange}
                                >
                                    {operateurs && operateurs.map((o) => {
                                        return (
                                            <MenuItem key={o.id} value={o["@id"]}>
                                                {o.libelle ?? o.email}
                                            </MenuItem>
                                        )
                                    })}
                                </Select>
                                {errors.operateur &&
                                    String(errors.operateur) &&
                                    <FormHelperText error={true}>{errors.operateur}</FormHelperText>}
                            </FormControl>
                        )}
                    </Field>
                </Grid>
            </Grid>

        </Grid>
    );
}

export default LaveuseDataField;
